<template>
  <slot></slot>
  <modal :id="modalId" :title="title">
    <form :id="formId" :action="action" method="POST" role="form">

      <div v-if="deleting">
          <p>Are you sure you want to delete <em>'{{ name }}'</em>?</p>
      </div>
      <div v-else>
        <div class="form-group row">
          <label for="inputName" class="col-sm-2 col-form-label">Name:</label>
          <div class="col-sm-10">
            <input type="text" name="name" id="inputName" class="form-control" required="required" v-model="name" placeholder="E.g. Hurricane Sandy">
          </div>
        </div>

        <div class="form-group row">
          <label for="inputYear" class="col-sm-2 col-form-label">Year:</label>
          <div class="col-sm-10">
            <input type="text" name="year" id="inputYear" class="form-control" required="required" v-model="year" placeholder="E.g. 2017">
          </div>
        </div>
        <div class="form-group row">
          <label for="inputXaCode" class="col-sm-2 col-form-label">XA Code:</label>
          <div class="col-sm-10">
            <input type="text" name="xa_code" id="inputXaCode" class="form-control" v-model="xaCode" placeholder="Catastrophe code from XA, multiple comma-separated values allowed, case-insensitive">
          </div>
        </div>
      </div>

      <input type="hidden" name="_method" :value="method">
      <input type="hidden" name="_token" :value="$csrf_token">
    </form>

    <template #footer>
      <template v-if="deleting">
        <button type="button" class="btn btn-default" @click.prevent="cancelDeletion"><i class="fa fa-fw fa-ban"></i> Cancel</button>
        <button type="submit" class="btn btn-danger" :form="formId"><i class="fa fa-fw fa-trash"></i> Delete</button>
      </template>
      <template v-else>
        <button type="button" class="btn btn-danger mr-auto" v-if="isExisting" @click.prevent="confirmDeletion"><i class="fa fa-fw fa-trash"></i> Delete</button>
        <button type="button" class="btn btn-default" @click="hideModal"><i class="fa fa-fw fa-ban"></i> Close</button>
        <button type="submit" class="btn btn-primary" :form="formId" :disabled="isEmpty"><i class="fa fa-fw fa-save"></i> Save changes</button>
      </template>
    </template>
  </modal>
</template>

<script>
import HasModal from "./mixins/HasModal";
export default {
  mixins: [HasModal],

  props: {
    // Custom id for modal component.
    modalId: {
      type: String,
      default: 'storms-modal'
    },
    id: {
      type: Number,
      default: 0
    },
    action: {
      type: String,
      required: true
    },
    initialName: {
      type: String,
      default: ''
    },
    initialYear: {
      type: String,
      default: ''
    },
    initialXaCode: {
      type: String,
      default: ''
    },
  },

  data() {
    return {
      name: this.initialName,
      year: this.initialYear,
      xaCode: this.initialXaCode,
      deleting: false
    };
  },
  computed: {
    formId() {
      return this.modalId + '-form';
    },
    title() {
      if (this.deleting) return 'Delete storm';
      return this.isNew ? "Add a storm" : "Edit storm";
    },
    method() {
      if (this.deleting) return 'DELETE';
      return this.isNew ? "POST" : "PATCH";
    },
    hasData() {
      return !!(this.name && this.name.trim().length && this.year);
    },
    isEmpty() {
      return !this.hasData;
    },
    isExisting() {
      return this.id > 0;
    },
    isNew() {
      return !this.isExisting;
    }
  },
  methods: {
    confirmDeletion() {
      this.deleting = true;
    },
    cancelDeletion() {
      this.deleting = false;
    },
  }
}

</script>
